import React from 'react';

const InfoItem = ({ text, value, tooltip, tooltipText }) => (
  <div className="stocks-info-item">
    <div className="text">{text}</div>
    <div className="value">
      <div style={{ float: 'left' }}>{value}</div>
      {tooltip && (
        <div className="client-info-icon">
          <div className="tooltip in-stocks-item">{tooltipText}</div>
        </div>
      )}
    </div>
  </div>
);

export default InfoItem;
